export default __webpack_public_path__ + "static/media/quotes_start.fe0be443.svg";